import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { cloneDeep } from 'lodash-es';
import { Observable, Subscription } from 'rxjs';
import { Offer } from '../../../../../domain/offer.domain';
import { SummaryType } from '../../../../../domain/product.domain';
import { IOfferAction } from '../../../store/ioffer.action';
import { IOfferState } from '../../../store/ioffer.state';

@Component({
    selector: 'app-ioffer',
    templateUrl: './ioffer.component.html',
    styleUrls: ['./ioffer.component.scss']
})
export class IOfferComponent implements OnInit, OnDestroy {

    @Select(IOfferState.getOffer) offer$: Observable<Offer>;
    subscriptions: Subscription[] = [];
    offer: Offer;
    summaryType = SummaryType;


    ngOnInit(): void {
        this.subscriptions.push(
            this.offer$.subscribe(offer => this.offer = cloneDeep(offer))
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    constructor(private store: Store) {
    }

    cancel() {
        this.store.dispatch(new IOfferAction.CancelOffer());
    }

    accept() {
        this.store.dispatch(new IOfferAction.AcceptOffer());
    }
}
